// @flow
import React from 'react';

import SimpleTable from './SimpleTable';

export default SimpleTable;
